"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hooks = void 0;
/**
 * Represents the hooks of the chart.
 */
var Hooks = /** @class */ (function () {
    function Hooks() {
        /**
         * Stores the hooks.
         */
        this.hooks = [];
    }
    /**
     * Appends a custom hook
     */
    Hooks.prototype.custom = function (hook) {
        this.hooks.push(hook);
        return this;
    };
    /**
     * Merges the given options to the chart.
     */
    Hooks.prototype.options = function (options) {
        return this.custom(function (_a) {
            var data = _a.data, merge = _a.merge;
            return merge(data, options);
        });
    };
    /**
     * Merges the given hooks with the current ones.
     */
    Hooks.prototype.merge = function (other) {
        this.hooks = __spreadArray(__spreadArray([], __read(this.hooks), false), __read(other.hooks), false);
        return this;
    };
    return Hooks;
}());
exports.Hooks = Hooks;
